// source: enum.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.enumeration.AmountType', null, global);
goog.exportSymbol('proto.enumeration.AuthMethod', null, global);
goog.exportSymbol('proto.enumeration.Chain', null, global);
goog.exportSymbol('proto.enumeration.DexVersion', null, global);
goog.exportSymbol('proto.enumeration.FileType', null, global);
goog.exportSymbol('proto.enumeration.MarketsSort', null, global);
goog.exportSymbol('proto.enumeration.NotificationType', null, global);
goog.exportSymbol('proto.enumeration.OrderSource', null, global);
goog.exportSymbol('proto.enumeration.OrderStatus', null, global);
goog.exportSymbol('proto.enumeration.OrderTriggerType', null, global);
goog.exportSymbol('proto.enumeration.OrderType', null, global);
goog.exportSymbol('proto.enumeration.PriorityFeeMultiplier', null, global);
goog.exportSymbol('proto.enumeration.ReferralLevel', null, global);
goog.exportSymbol('proto.enumeration.Side', null, global);
goog.exportSymbol('proto.enumeration.TimeUnit', null, global);
goog.exportSymbol('proto.enumeration.TradePresetType', null, global);
goog.exportSymbol('proto.enumeration.TransactionStatus', null, global);
goog.exportSymbol('proto.enumeration.TransactionType', null, global);
/**
 * @enum {number}
 */
proto.enumeration.Chain = {
  CHAIN_UNKNOWN: 0,
  CHAIN_SOLANA: 1,
  CHAIN_ETHEREUM: 2
};

/**
 * @enum {number}
 */
proto.enumeration.TimeUnit = {
  TIMEUNIT_UNKNOWN: 0,
  TIMEUNIT_SECONDS: 1,
  TIMEUNIT_MINUTES: 2,
  TIMEUNIT_HOURS: 3,
  TIMEUNIT_DAYS: 4,
  TIMEUNIT_WEEKS: 5,
  TIMEUNIT_MONTHS: 6,
  TIMEUNIT_YEARS: 7
};

/**
 * @enum {number}
 */
proto.enumeration.Side = {
  SIDE_UNKNOWN: 0,
  SIDE_BUY: 1,
  SIDE_SELL: 2
};

/**
 * @enum {number}
 */
proto.enumeration.OrderType = {
  ORDERTYPE_UNKNOWN: 0,
  ORDERTYPE_TAKEPROFIT: 1,
  ORDERTYPE_STOPLOSS: 2
};

/**
 * @enum {number}
 */
proto.enumeration.OrderSource = {
  ORDERSOURCE_UNKNOWN: 0,
  ORDERSOURCE_TERMINAL: 1,
  ORDERSOURCE_SNIPING: 2,
  ORDERSOURCE_COPYTRADING: 3,
  ORDERSOURCE_AUTOINVESTING: 4,
  ORDERSOURCE_QUICKBUY: 5
};

/**
 * @enum {number}
 */
proto.enumeration.OrderTriggerType = {
  ORDERTRIGGERTYPE_UNKNOWN: 0,
  ORDERTRIGGERTYPE_MARKETCAPPCT: 1,
  ORDERTRIGGERTYPE_PRICEPCT: 2,
  ORDERTRIGGERTYPE_PRICE: 3
};

/**
 * @enum {number}
 */
proto.enumeration.OrderStatus = {
  ORDERSTATUS_UNKNOWN: 0,
  ORDERSTATUS_FILLED: 1,
  ORDERSTATUS_ACTIVE: 2,
  ORDERSTATUS_WAITING: 3,
  ORDERSTATUS_EXPIRED: 4,
  ORDERSTATUS_CANCELED: 5
};

/**
 * @enum {number}
 */
proto.enumeration.AmountType = {
  AMOUNTTYPE_UNKNOWN: 0,
  AMOUNTTYPE_QUOTECURRENCY: 1,
  AMOUNTTYPE_BASECURRENCY: 2,
  AMOUNTTYPE_POSITIONPCT: 3
};

/**
 * @enum {number}
 */
proto.enumeration.DexVersion = {
  DEXVERSION_UNKNOWN: 0,
  DEXVERSION_UNISWAPV2: 1,
  DEXVERSION_UNISWAPV3: 2,
  DEXVERSION_UNISWAPV2_TESTNET: 3,
  DEXVERSION_UNISWAPV3_TESTNET: 4,
  DEXVERSION_RADIUM_MAINNET: 5,
  DEXVERSION_RADIUM_DEVNET: 6
};

/**
 * @enum {number}
 */
proto.enumeration.ReferralLevel = {
  REFERRALLEVEL_UNKNOWN: 0,
  REFERRALLEVEL_1: 1,
  REFERRALLEVEL_2: 2,
  REFERRALLEVEL_3: 3
};

/**
 * @enum {number}
 */
proto.enumeration.TradePresetType = {
  TRADEPRESETTYPE_UNKNOWN: 0,
  TRADEPRESETTYPE_LIMITBUY: 1,
  TRADEPRESETTYPE_LIMITSELL: 2,
  TRADEPRESETTYPE_SWAPBUY: 3,
  TRADEPRESETTYPE_SWAPSELL: 4,
  TRADEPRESETTYPE_APPROVE: 5,
  TRADEPRESETTYPE_SNIPING: 6,
  TRADEPRESETTYPE_COPYTRADING: 7,
  TRADEPRESETTYPE_AUTOINVEST: 8,
  TRADEPRESETTYPE_QUICKBUY: 9
};

/**
 * @enum {number}
 */
proto.enumeration.TransactionStatus = {
  TRANSACTIONSTATUS_UNKNOWN: 0,
  TRANSACTIONSTATUS_PENDING: 1,
  TRANSACTIONSTATUS_CONFIRMED: 2,
  TRANSACTIONSTATUS_FAILED: 3,
  TRANSACTIONSTATUS_DROPPED: 4,
  TRANSACTIONSTATUS_REVERTED: 5,
  TRANSACTIONSTATUS_REPLACED: 6
};

/**
 * @enum {number}
 */
proto.enumeration.TransactionType = {
  TRANSACTIONTYPE_UNKNOWN: 0,
  TRANSACTIONTYPE_DEPOSIT: 1,
  TRANSACTIONTYPE_WITHDRAWAL: 2,
  TRANSACTIONTYPE_TRANSFER: 3,
  TRANSACTIONTYPE_AIRDROP: 4,
  TRANSACTIONTYPE_TOKENMINT: 5,
  TRANSACTIONTYPE_REVOKEMINT: 6,
  TRANSACTIONTYPE_LPCREATE: 7,
  TRANSACTIONTYPE_LIQUIDITY: 8,
  TRANSACTIONTYPE_BLACKLIST: 9,
  TRANSACTIONTYPE_TAX: 10,
  TRANSACTIONTYPE_BUYSWAP: 11,
  TRANSACTIONTYPE_SELLSWAP: 12,
  TRANSACTIONTYPE_REFERRAL: 13,
  TRANSACTIONTYPE_ADMIN: 14,
  TRANSACTIONTYPE_APPROVE: 15
};

/**
 * @enum {number}
 */
proto.enumeration.AuthMethod = {
  AUTHMETHOD_UNKNOWN: 0,
  AUTHMETHOD_SOLWALLET: 1,
  AUTHMETHOD_ETHWALLET: 2,
  AUTHMETHOD_TELEGRAM: 3
};

/**
 * @enum {number}
 */
proto.enumeration.NotificationType = {
  NOTIFICATIONTYPE_UNKNOWN: 0,
  NOTIFICATIONTYPE_SYSTEM: 1,
  NOTIFICATIONTYPE_TRADE: 2,
  NOTIFICATIONTYPE_WATCHLIST: 3,
  NOTIFICATIONTYPE_SECURITY: 4
};

/**
 * @enum {number}
 */
proto.enumeration.FileType = {
  FILETYPE_UNKNOWN: 0,
  FILETYPE_CSV: 1,
  FILETYPE_EXCEL: 2
};

/**
 * @enum {number}
 */
proto.enumeration.PriorityFeeMultiplier = {
  PRIORITYFEEMULTIPLIER_UNKNOWN: 0,
  PRIORITYFEEMULTIPLIER_1X: 1,
  PRIORITYFEEMULTIPLIER_2X: 2,
  PRIORITYFEEMULTIPLIER_3X: 3
};

/**
 * @enum {number}
 */
proto.enumeration.MarketsSort = {
  MARKETSSORT_UNKNOWN: 0,
  MARKETSSORT_CREATEDAT: 1,
  MARKETSSORT_TXCOUNTLAST5M: 2,
  MARKETSSORT_TXCOUNTLAST1H: 3,
  MARKETSSORT_TXCOUNTLAST6H: 4,
  MARKETSSORT_TXCOUNTLAST24H: 5
};

goog.object.extend(exports, proto.enumeration);
